import React from 'react';
import {
    Button,
    Form,
    Header,
    Segment,
    Input,
    Select,
    Grid,
    Tab,
    Responsive,
    Icon,
    Popup,
    Loader, Table, Divider
} from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { DateTimePicker } from 'react-widgets';
import request from '../../../util/request';
import PlaceForm from '../../../util/PlaceForm';
import PreviousEducations from '../../../StudentService/StudentCreateAndEdit/PreviousEducations';
import {FiltersOnStyle, IconHeader, IconHeaderP} from '../../../Professor/ProfessorInputGrades/css';
import HRFilters from '../../HRFilters';

export default class EditPersonInfo extends React.Component {
    constructor(props) {
        super(props);
        const { person } = this.props;
        this.state = {
            addedNewEducation: false,
            activeIndex: 0,
            jmbg: person.jmbg,
            firstName: person.firstName,
            lastName: person.lastName,
            dateOfBirth: person.dateOfBirth ? new Date(person.dateOfBirth) : null,
            genders: [],
            gender: person.gender ? person.gender.id : null,
            maidenName: person.maidenName ? person.maidenName : null,
            nationalities: [],
            selectedCitizenships: person.citizenships ? person.citizenships.map(el => (el.country.id)) : null,
            citizenships: [],
            nationality: person.nationality ? person.nationality.id : null,

            motherFirstName: person.mother ? person.mother.firstName : null,
            motherLastName: person.mother ? person.mother.lastName : null,
            fatherFirstName: person.father ? person.father.firstName : null,
            fatherLastName: person.father ? person.father.lastName : null,

            bihId: null,
            fbihId: null,
            bdId: null,

            personId: null,

            jmbgErr: false,
            firstNameErr: false,
            lastNameErr: false,
            dateOfBirthErr: false,
            genderErr: false,
            placeOfBirthErr: false,
            residenceErr: false,
            currentResidenceErr: false,
            selectedCitizenshipsErr: false,
            municipalities: [],

            institutionTypes: [],
            institutionType: null,
            educationLevels: [],
            educationLevel: null,
            // previousEducations: person.previousEducations,


            placeOfBirth: {
                country: person.placeOfBirth ? person.placeOfBirth.country ? person.placeOfBirth.country.id : null : null,
                canton: person.placeOfBirth ? person.placeOfBirth.canton ? person.placeOfBirth.canton.id : null : null,
                municipality: person.placeOfBirth ? person.placeOfBirth.municipality ? person.placeOfBirth.municipality.id : null : null,
                entity: person.placeOfBirth ? person.placeOfBirth.entity ? person.placeOfBirth.entity.id : null : null,
                place: person.placeOfBirth ? person.placeOfBirth.name ? person.placeOfBirth.name : null : null
            },

            placeOfResidence: {
                country: person.residence ? person.residence.place ? person.residence.place.country ? person.residence.place.country.id : null : null : null,
                entity: person.residence ? person.residence.place ? person.residence.place.entity ? person.residence.place.entity.id : null : null : null,
                canton: person.residence ? person.residence.place ? person.residence.place.canton ? person.residence.place.canton.id : null : null : null,
                municipality: person.residence ? person.residence.place ? person.residence.place.municipality ? person.residence.place.municipality.id : null : null : null,
                place: person.residence ? person.residence.place ? person.residence.place.name ? person.residence.place.name : null : null : null,
                address: person.residence ? person.residence.street ? person.residence.street : null : null
            },

            placeOfCurrentResidence: {
                country: person.currentResidence ? person.currentResidence.place ? person.currentResidence.place.country ? person.currentResidence.place.country.id : null : null : null,
                entity: person.currentResidence ? person.currentResidence.place ? person.currentResidence.place.entity ? person.currentResidence.place.entity.id : null : null : null,
                canton: person.currentResidence ? person.currentResidence.place ? person.currentResidence.place.canton ? person.currentResidence.place.canton.id : null : null : null,
                municipality: person.currentResidence ? person.currentResidence.place ? person.currentResidence.place.municipality ? person.currentResidence.place.municipality.id : null : null : null,
                place: person.currentResidence ? person.currentResidence.place ? person.currentResidence.place.name ? person.currentResidence.place.name : null : null : null,
                address: person.currentResidence ? person.currentResidence.street ? person.currentResidence.street : null : null
            },

        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onPlaceChange = this.onPlaceChange.bind(this);
        this.editPerson = this.editPerson.bind(this);
        this.onAddNewPreviousEducation = this.onAddNewPreviousEducation.bind(this);
        this.onDeletePreviousEducation = this.onDeletePreviousEducation.bind(this);
    }
    componentDidMount() {
        request.fetchNationalitiesWithDefaultKey()
            .then(({ nationalities, defaultUnknownNationalityId }) => {
                this.setState({ nationalities });
            }).catch(err => console.log(err));
        request.fetchCountriesWithDefaultKey()
            .then(({ bihId }) => this.setState({ bihId }));
        request.fetchEntitiesWithDefaultKey()
            .then(({ fbihId }) => this.setState({ fbihId }));

        request.fetchInstitutionTypes()
            .then(institutionTypes => this.setState({ institutionTypes }));

        request.fetchEducationLevels()
            .then(educationLevels => this.setState({ educationLevels }));


        axios.get('/entities')
            .then(res => {
                this.setState({ bdId: res.data.find(el => el._key === 'bd').id });
            });

        axios.get('/municipalities')
            .then(res => {
                const municipalities = res.data.map(el => ({
                    ...el,
                    key: el.id,
                    value: el.id,
                    text: el.name,
                    cantonId: el.canton != null ? el.canton.id : ''
                }));
                this.setState({ municipalities });
            })
            .catch(err => {
                console.log('Failed to fetch municipalities.');
            });

        axios.get('/countries')
            .then(res => {
                const citizenships = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ citizenships });
            })
            .catch(err => {
                console.log('Failed to fetch citizenships');
            });

        axios.get('/genders')
            .then(res => {
                const genders = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ genders });
            })
            .catch(err => {
                console.log('Failed to fetch genders');
            });
    }


    handleDateChange(date) {
        this.setState({ dateOfBirth: date });
    }
    handleInputChange(e, { name, value }) {
        if (name === 'gender') { this.setState({ maidenName: '' }); }
        this.setState({ [name]: value });
    }
    showNationality() {
        return !!this.state.selectedCitizenships.find(el => this.state.bihId === el);
    }

    onPlaceChange(values, formName) {
        this.setState({ [formName]: values });
    }

    onAddNewPreviousEducation(prevEducation) {
        const { previousEducations } = this.state;
        this.setState({ previousEducations: [...previousEducations, prevEducation], addedNewEducation: true });
    }
    onDeletePreviousEducation(index) {
        const filtered = this.state.previousEducations.filter((el, i) => i !== index);
        console.log('filtered', filtered)
        this.setState({ previousEducations: filtered,  addedNewEducation: true });
    }


    editPerson() {
        const { person } = this.props;
        const {
            jmbg,
            firstName,
            lastName,
            dateOfBirth,
            gender,
            maidenName,
            selectedCitizenships,
            nationality,
            placeOfBirth,
            placeOfResidence,
            placeOfCurrentResidence,
            motherFirstName,
            motherLastName,
            fatherFirstName,
            fatherLastName,
            fbihId,
            bdId

        } = this.state;



        let obj = {
            id: person.id,
            optLock: person.optLock,
            jmbg,
            firstName,
            lastName,
            maidenName,
            dateOfBirth,
            gender: { id: gender, optLock: person.gender ? person.gender.optLock : null },
            citizenships: selectedCitizenships.map((el, index) =>
                ({
                    country: { id: el },
                    priority: index + 1
                })),
            nationality: nationality ? selectedCitizenships.find(e => e === this.state.bihId) ? { id: nationality, optLock: person.nationality ? person.nationality.optLock : null } : null : null,

            placeOfBirth: {
                name: placeOfBirth.place,
                country: { id: placeOfBirth.country },
                entity: placeOfBirth.entity ? { id: placeOfBirth.entity } : null,
                canton: fbihId !== placeOfBirth.entity ? null : placeOfBirth.canton ? { id: placeOfBirth.canton } : null,
                municipality: placeOfBirth.entity ? placeOfBirth.municipality ? { id: placeOfBirth.municipality } : null : null,
                id: person.placeOfBirth ? person.placeOfBirth.id : null,
                optLock: person.placeOfBirth ? person.placeOfBirth.optLock : null
            },
            residence: {
                street: placeOfResidence.address,
                place: {
                    name: placeOfResidence.place,
                    country: { id: placeOfResidence.country },
                    entity: placeOfResidence.entity ? { id: placeOfResidence.entity } : null,
                    canton: fbihId !== placeOfResidence.entity ? null : placeOfResidence.canton ? { id: placeOfResidence.canton } : null,
                    municipality: placeOfResidence.entity ? placeOfResidence.municipality ? { id: placeOfResidence.municipality } : null : null
                },

                id: person.residence ? person.residence.id : null,
                optLock: person.residence ? person.residence.optLock : null
            }
        };
        if (placeOfCurrentResidence) {
            obj = {
                ...obj,
                currentResidence: (placeOfCurrentResidence.country === '' || !placeOfCurrentResidence.country) ? null
                    : {
                        street: placeOfCurrentResidence.address,
                        place: {
                            name: placeOfCurrentResidence.place,
                            country: { id: placeOfCurrentResidence.country },
                            entity: placeOfCurrentResidence.entity ? { id: placeOfCurrentResidence.entity } : null,
                            canton: fbihId !== placeOfCurrentResidence.entity ? null : placeOfCurrentResidence.canton ? { id: placeOfCurrentResidence.canton } : null,
                            municipality: placeOfCurrentResidence.entity ? placeOfCurrentResidence.municipality ? { id: placeOfCurrentResidence.municipality } : null : null
                        },

                        id: person.currentResidence ? person.currentResidence.id : null,
                        optLock: person.currentResidence ? person.currentResidence.optLock : null
                    }
            };
        }

        let mother = {
            gender: { id: 2 },
            firstName: motherFirstName,
            lastName: motherLastName,
            id: person.mother ? person.mother.id : null,
            optLock: person.mother ? person.mother.optLock : null,
        };

        let father = {
            gender: { id: 1 },
            firstName: fatherFirstName,
            lastName: fatherLastName,
            id: person.father ? person.father.id : null,
            optLock: person.father ? person.father.optLock : null,

        };

        if (motherLastName || motherFirstName) obj = { ...obj, mother };
        if (fatherLastName || fatherFirstName) obj = { ...obj, father };

        // let previousEducations = this.state.previousEducations.map(el => ({
        //     comment: el.comment,
        //     averageGrade: el.averageGrade,
        //     licenceNumber: el.licenceNumber,
        //     educationLevel: { id: el.educationLevel.id ? el.educationLevel.id : el.educationLevel?el.educationLevel:null },
        //     institution: { id: el.institution.id },
        //     id: el.id ? el.id : null,
        //     optLock: el.optLock
        // }));

       // if(localStorage.getItem('academicStaff') === 'false'){
       //     if (previousEducations.length && this.state.addedNewEducation) obj = { ...obj, previousEducations };
       //     else if(!previousEducations.length){
       //         obj = { ...obj, previousEducations: [] };
       //     } else{
       //         obj = { ...obj, previousEducations: null };
       //
       //     }
       //
       // }
        if (!this.state.jmbg || !this.state.firstName || !this.state.lastName || !this.state.gender
            || (this.state.selectedCitizenships.length === 0) ||

            !this.state.placeOfResidence.country ||
            ((this.state.placeOfResidence.country && this.state.placeOfResidence.country === this.state.bihId) && !this.state.placeOfResidence.entity) ||
            ((this.state.placeOfResidence.entity && this.state.placeOfResidence.entity === this.state.fbihId)
                && (!this.state.placeOfResidence.canton || !this.state.placeOfResidence.municipality))
            || (this.state.placeOfResidence.entity && this.state.placeOfResidence.entity === this.state.rsId && !this.state.placeOfResidence.municipality)
            || !this.state.placeOfResidence.address || !this.state.placeOfResidence.place ||

            !this.state.placeOfBirth.country ||
            ((this.state.placeOfBirth.country && this.state.placeOfBirth.country === this.state.bihId) && !this.state.placeOfBirth.entity) ||
            ((this.state.placeOfBirth.entity && this.state.placeOfBirth.entity === this.state.fbihId)
                && (!this.state.placeOfBirth.canton || !this.state.placeOfBirth.municipality))
            || (this.state.placeOfBirth.entity && this.state.placeOfBirth.entity === this.state.rsId && !this.state.placeOfBirth.municipality)
            || !this.state.placeOfBirth.place ||

            (this.state.placeOfCurrentResidence.country &&
                (!this.state.placeOfCurrentResidence.place || !this.state.placeOfCurrentResidence.address
                    || ((this.state.placeOfCurrentResidence.country === this.state.bihId) && !this.state.placeOfCurrentResidence.entity))
                || (this.state.placeOfCurrentResidence.entity && this.state.placeOfCurrentResidence.entity === this.state.fbihIdb
                    && (!this.state.placeOfCurrentResidence.canton || !this.state.placeOfCurrentResidence.municipality))
                || (this.state.placeOfCurrentResidence.entity && this.state.placeOfCurrentResidence.entity === this.state.rsId && !this.state.placeOfCurrentResidence.municipality)
            )
        ) {
            toast('Niste unijeli sva obavezna polja!');
            if (!this.state.jmbg) { this.setState({ jmbgErr: true }); } else { this.setState({ jmbgErr: false }); }
            if (!this.state.firstName) { this.setState({ firstNameErr: true }); } else { this.setState({ firstNameErr: false }); }
            if (!this.state.lastName) { this.setState({ lastNameErr: true }); } else { this.setState({ lastNameErr: false }); }
            if (!this.state.gender) { this.setState({ genderErr: true }); } else { this.setState({ genderErr: false }); }
            if (this.state.selectedCitizenships.length === 0) { this.setState({ citizenshipsErr: true }); } else { this.setState({ citizenshipsErr: false }); }

            if (!this.state.placeOfResidence.country) { this.setState({ placeOfResidenceCountryErr: true }); } else { this.setState({ placeOfResidenceCountryErr: false }); }
            if (!this.state.placeOfResidence.address) { this.setState({ placeOfResidenceAddressErr: true }); } else { this.setState({ placeOfResidenceAddressErr: false }); }
            if (!this.state.placeOfResidence.place) { this.setState({ placeOfResidencePlaceErr: true }); } else { this.setState({ placeOfResidencePlaceErr: false }); }

            if (this.state.placeOfResidence.country === this.state.bihId) {
                if (!this.state.placeOfResidence.entity) { this.setState({ placeOfResidenceEntityErr: true }); } else { this.setState({ placeOfResidenceEntityErr: false }); }
                if (this.state.placeOfResidence.entity === this.state.fbihId) {
                    if (!this.state.placeOfResidence.canton) { this.setState({ placeOfResidenceCantonErr: true }); } else { this.setState({ placeOfResidenceCantonErr: false }); }
                    if (!this.state.placeOfResidence.municipality) { this.setState({ placeOfResidenceMunicipalityErr: true }); } else { this.setState({ placeOfResidenceMunicipalityErr: false }); }
                }
                if (this.state.placeOfResidence.entity === this.state.rsId) {
                    if (!this.state.placeOfResidence.municipality) { this.setState({ placeOfResidenceMunicipalityErr: true }); } else { this.setState({ placeOfResidenceMunicipalityErr: false }); }
                }
            }

            if (!this.state.placeOfBirth.country) { this.setState({ placeOfBirthCountryErr: true }); } else { this.setState({ placeOfBirthCountryErr: false }); }
            if (!this.state.placeOfBirth.place) { this.setState({ placeOfBirthPlaceErr: true }); } else { this.setState({ placeOfBirthPlaceErr: false }); }

            if (this.state.placeOfBirth.country === this.state.bihId) {
                if (!this.state.placeOfBirth.entity) { this.setState({ placeOfBirthEntityErr: true }); } else { this.setState({ placeOfBirthEntityErr: false }); }
                if (this.state.placeOfBirth.entity === this.state.fbihId) {
                    if (!this.state.placeOfBirth.canton) { this.setState({ placeOfBirthCantonErr: true }); } else { this.setState({ placeOfBirthCantonErr: false }); }
                    if (!this.state.placeOfBirth.municipality) { this.setState({ placeOfBirthMunicipalityErr: true }); } else { this.setState({ placeOfBirthMunicipalityErr: false }); }
                }
                if (this.state.placeOfBirth.entity === this.state.rsId) {
                    if (!this.state.placeOfBirth.municipality) { this.setState({ placeOfBirthMunicipalityErr: true }); } else { this.setState({ placeOfBirthMunicipalityErr: false }); }
                }
            }

            if (this.state.placeOfCurrentResidence.country === this.state.bihId) {
                if (!this.state.placeOfCurrentResidence.entity) { this.setState({ placeOfCurrentResidenceEntityErr: true }); } else { this.setState({ placeOfCurrentResidenceEntityErr: false }); }
                if (this.state.placeOfCurrentResidence.entity === this.state.fbihId) {
                    if (!this.state.placeOfCurrentResidence.canton) { this.setState({ placeOfCurrentResidenceCantonErr: true }); } else { this.setState({ placeOfCurrentResidenceCantonErr: false }); }
                    if (!this.state.placeOfCurrentResidence.municipality) { this.setState({ placeOfCurrentResidenceMunicipalityErr: true }); } else { this.setState({ placeOfCurrentResidenceMunicipalityErr: false }); }
                }
                if (this.state.placeOfCurrentResidence.entity === this.state.rsId) {
                    if (!this.state.placeOfCurrentResidence.municipality) { this.setState({ placeOfCurrentResidenceMunicipalityErr: true }); } else { this.setState({ placeOfCurrentResidenceMunicipalityErr: false }); }
                }
            }
        }
        else{
            let academicStaff = null;
            let associate = false;
            if (localStorage.getItem('academicStaff') === 'true') academicStaff = true;
            if (localStorage.getItem('academicStaff') === 'false') academicStaff = false;
            if (localStorage.getItem('associate') === 'true') associate = true;
            // if(!academicStaff && previousEducations.length===0){
            // toast('Nenastavno osoblje mora imati podatke o prethodnom obrazovanju.')
            // }else{
                axios.put(`hr/person/edit/${academicStaff}/${associate}`, { ...obj })
                    .then(res => {
                        toast('Izmjena podataka o osobi je uspješno izvršena.');
                        this.props.getPerson(this.state.jmbg);
                    })
                    .catch(err => {
                        toast('Došlo je do greške! Izmjena podataka nije izvršena.');
                        // this.props.back();
                    });
            // }

        }

    }

    handleTabChange = (e, { activeIndex }) => this.setState({ activeIndex })


    render() {
        const panes = [
            {
                menuItem: 'Osnovne informacije',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>
                        <Form>
                            <Form.Field
                                required
                                type="number"
                                control={Input}
                                label="JMBG"
                                placeholder="JMBG"
                                value={this.state.jmbg}
                                name="jmbg"
                                onChange={this.handleInputChange}
                                error={this.state.jmbgErr}
                            />

                            <Form.Field
                                required
                                control={Input}
                                label="Ime"
                                placeholder="Ime"
                                value={this.state.firstName}
                                name="firstName"
                                onChange={this.handleInputChange}
                                error={this.state.firstNameErr}
                            />
                            <Form.Field
                                required
                                control={Input}
                                label="Prezime"
                                placeholder="Prezime"
                                value={this.state.lastName}
                                name="lastName"
                                onChange={this.handleInputChange}
                                error={this.state.lastNameErr}
                            />
                            <Form.Field
                                required
                                control={DateTimePicker}
                                label="Datum rođenja"
                                format="D. M. YYYY."
                                time={false}
                                onChange={this.handleDateChange}
                                value={this.state.dateOfBirth}
                                style={{ borderWidth: '0px' }}
                                error={this.state.dateOfBirthErr}
                            />
                            <Form.Field
                                required
                                control={Select}
                                label="Spol"
                                options={this.state.genders}
                                placeholder="Spol"
                                onChange={this.handleInputChange}
                                name="gender"
                                value={this.state.gender}
                                error={this.state.genderErr}
                            />
                            <Form.Field
                                control={Input}
                                label="Djevojačko prezime"
                                placeholder="Djevojačko prezime"
                                value={this.state.maidenName}
                                name="maidenName"
                                onChange={this.handleInputChange}
                                disabled={this.state.gender === null || this.state.gender === 1}
                                // error={this.state.lastNameErr}
                            />
                            <Form.Field required error={this.state.selectedCitizenshipsErr}>
                                <label>Državljanstvo</label>
                                <Form.Dropdown
                                    selection
                                    required
                                    options={this.state.citizenships}
                                    onChange={this.handleInputChange}
                                    value={this.state.selectedCitizenships}
                                    name="selectedCitizenships"
                                    placeholder="Državljanstvo"
                                    search
                                    multiple
                                    fluid
                                />
                            </Form.Field>
                            <Form.Field
                                required
                                control={Select}
                                label="Nacionalnost"
                                options={this.state.nationalities}
                                value={this.state.nationality}
                                onChange={this.handleInputChange}
                                name="nationality"
                                search
                                disabled={!this.state.selectedCitizenships.find(el => el === this.state.bihId)}
                            />
                        </Form>
                    </div>
                </Tab.Pane>)
            },
            {
                menuItem: 'Mjesto rođenja',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>

                        <PlaceForm
                            values={this.state.placeOfBirth}
                            formName="placeOfBirth"
                            onPlaceChange={this.onPlaceChange}
                            fieldErr={this.state.placeOfBirthErr}
                            noAdress
                            countryErr={this.state.placeOfBirthCountryErr}
                            entityErr={this.state.placeOfBirthEntityErr}
                            cantonError={this.state.placeOfBirthCantonErr}
                            municipalityError={this.state.placeOfBirthMunicipalityErr}
                            placeErr={this.state.placeOfBirthPlaceErr}
                            municipalitiesStart={(this.state.placeOfBirth.canton && this.state.fbihId) ? this.state.municipalities.filter(el => el.cantonId === this.state.placeOfBirth.canton)
                                : this.state.placeOfBirth.entity ? this.state.municipalities.filter(el => el.entity && el.entity.id === this.state.placeOfBirth.entity) : []}
                            bdId={this.state.bdId}
                        />
                    </div>

                </Tab.Pane>)
            },
            {
                menuItem: 'Podaci o roditeljima',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>
                        <Form>
                            <Form.Field
                                control={Input}
                                label="Ime oca"
                                placeholder="Ime oca"
                                value={this.state.fatherFirstName}
                                name="fatherFirstName"
                                onChange={this.handleInputChange}
                            />
                            <Form.Field
                                control={Input}
                                label="Prezime oca"
                                placeholder="Prezime oca"
                                value={this.state.fatherLastName}
                                name="fatherLastName"
                                onChange={this.handleInputChange}
                            />
                            <br />
                            <br />
                            <br />
                            <br />

                            <Form.Field
                                control={Input}
                                label="Ime majke"
                                placeholder="Ime majke"
                                value={this.state.motherFirstName}
                                name="motherFirstName"
                                onChange={this.handleInputChange}
                            />
                            <Form.Field
                                control={Input}
                                label="Prezime majke"
                                placeholder="Prezime majke"
                                value={this.state.motherLastName}
                                name="motherLastName"
                                onChange={this.handleInputChange}
                            />
                        </Form>

                    </div>

                </Tab.Pane>)
            },
            {
                menuItem: 'Prebivalište i boravište',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>

                        <Grid columns="equal" centered className="stackable">
                            <Grid.Row streched>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4">Prebivalište</Header>
                                    </Divider>
                                    <PlaceForm
                                        countryErr={this.state.placeOfResidenceCountryErr}
                                        entityErr={this.state.placeOfResidenceEntityErr}
                                        cantonError={this.state.placeOfResidenceCantonErr}
                                        municipalityError={this.state.placeOfResidenceMunicipalityErr}
                                        placeErr={this.state.placeOfResidencePlaceErr}
                                        addressErr={this.state.placeOfResidenceAddressErr}
                                        values={this.state.placeOfResidence}
                                        formName="placeOfResidence"
                                        onPlaceChange={this.onPlaceChange}
                                        fieldErr={this.state.residenceErr}
                                        municipalitiesStart={(this.state.placeOfResidence.canton && this.state.fbihId) ? this.state.municipalities.filter(el => el.cantonId === this.state.placeOfResidence.canton)
                                            : this.state.placeOfResidence.entity ? this.state.municipalities.filter(el => el.entity && el.entity.id === this.state.placeOfResidence.entity) : []}
                                        bdId={this.state.bdId}

                                    /></Grid.Column>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4">Boravište</Header>
                                    </Divider>
                                    <PlaceForm
                                        values={this.state.placeOfCurrentResidence}
                                        formName="placeOfCurrentResidence"
                                        onPlaceChange={this.onPlaceChange}
                                        fieldErr={this.state.currentResidenceErr}
                                        municipalitiesStart={(this.state.placeOfCurrentResidence.canton && this.state.fbihId) ? this.state.municipalities.filter(el => el.cantonId === this.state.placeOfCurrentResidence.canton)
                                            : this.state.placeOfCurrentResidence.entity ? this.state.municipalities.filter(el => el.entity && el.entity.id === this.state.placeOfCurrentResidence.entity) : []}
                                        bdId={this.state.bdId}
                                    /></Grid.Column>
                            </Grid.Row></Grid>
                    </div>

                </Tab.Pane>)
            },
            // // localStorage.getItem('academicStaff') === 'false' &&
            // {
            //     menuItem: 'Prethodno obrazovanje',
            //     render: () => (<Tab.Pane attached={false} as={Responsive}>
            //         <div>
            //             <PreviousEducations
            //                 noSegment
            //                 institutionTypes={this.state.institutionTypes}
            //                 educationLevels={this.state.educationLevels}
            //                 institutions={this.state.institutions}
            //                 onAddNewPreviousEducation={this.onAddNewPreviousEducation}
            //                 previousEducations={this.state.previousEducations}
            //                 onDeletePreviousEducation={this.onDeletePreviousEducation}
            //             />
            //         </div>
            //
            //     </Tab.Pane>)
            // }
        ];
        return (

            <div>
                    <Divider horizontal>
                        <Header as="h4">
                            Izmjena ličnih podataka
                        </Header>
                    </Divider>
                <br/>

                <Tab
                    menu={{
                        secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true
                    }}
                    grid={{ paneWidth: 13, tabWidth: 3 }}
                    panes={panes}
                    onTabChange={this.handleTabChange}
                    activeIndex={this.state.activeIndex}
                />

                <Segment vertical clearing/>
                <Segment vertical clearing>



                    <Grid columns={3}>
                        <Grid.Column ><Button  compact icon='left arrow'  basic color='blue'  disabled={this.state.activeIndex === 0}
                                onClick={()=> this.setState({activeIndex: this.state.activeIndex-1})} floated="left"/>
                        </Grid.Column>
                        <Grid.Column textAlign="center">
                            <Popup
                                content="Sačuvaj izmjene"
                                position="top center"
                                trigger={<Button basic color={'green'} onClick={this.editPerson} compact circular icon={'check'}/>}
                            />
                            <Popup
                                content="Odustani"
                                position="top center"
                                trigger={ <Button icon={'close'} basic color={'blue'} circular compact onClick={this.props.back}/>}
                            />


                        </Grid.Column>
                        <Grid.Column >
                        <Button  icon='right arrow' floated={'right'} basic color='blue' compact disabled={this.state.activeIndex >= 3}
                                onClick={()=> this.setState({activeIndex: this.state.activeIndex+1})} />
                        </Grid.Column>
                    </Grid>


                </Segment>
                <ToastContainer hideProgressBar />

            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/views/HR/profile/Employee/EditPersonInfo.js